import { resourceHost } from '@/environment'
import { countries } from '@/countries'
/**
 * Common used configurations for OMO and meinbuero builds.
 * This file structue is requied because of the current webpack build config, which has a special case module handling
 * on the for *.meinbuero.js files
 *
 * TODO add all common use config for OMO and meinbuero here
 *
 */

const paypalBaseUrl = ENV.build === 'production' ? 'www.paypal.com' : 'www.sandbox.paypal.com'

const monthLabelMapping = {
  january: 'Januar',
  february: 'Februar',
  march: 'März',
  april: 'April',
  may: 'Mai',
  june: 'Juni',
  july: 'Juli',
  august: 'August',
  september: 'September',
  october: 'Oktober',
  november: 'November',
  december: 'Dezember',
}
const monthLabels = Object.values(monthLabelMapping)

const dayLabelMapping = {
  sunday: 'Sonntag',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
}
const dayLabels = Object.values(dayLabelMapping)
const shortDayLabels = dayLabels.map((day) => day.slice(0, 2))

// advanced datepicker
const advancedDatepicker = {
  custom: 'Benutzerdefiniert',
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4',
  wholeYear: 'Ganzes Jahr',
}

export default {
  banking: {
    redirectBackTarget: 'landing/banking/finalized',
  },
  paypal: {
    businessSupportLink: 'https://www.paypal.com/businessprofile/mytools/apiaccess/firstparty/signature',
    manageApiAccessLink: `https://${paypalBaseUrl}/businessprofile/partner/consents`,
  },
  stripe: {
    manageAccountConnectLink: 'https://dashboard.stripe.com/settings/account',
  },
  customFields: {
    articleType: 'article',
    customerType: 'customer',
  },
  headers: {
    apiClient: 'X-Invoiz-Client',
  },
  apiClients: {
    web: 'web',
    electron: 'electron',
  },
  // search endpoint
  getAllCustomers: `${resourceHost}find/customer/*`,
  getAllArticles: `${resourceHost}find/article/*`,
  getCityToZipCode: `${resourceHost}find/city`,

  // service contract endpoints
  serviceHost: `${resourceHost}deltraservices`,

  dateEpochValue: '1899-12-30',
  datetimeEpochValue: '1899-12-30T00:00',

  // date + time formats
  datetimeFormat: {
    api: 'YYYY-MM-DDTHH:mm',
    client: 'H:mm',
    dateTime: 'DD.MM.YYYY - hh:mm',
    dateTime24: 'DD.MM.YYYY - HH:mm',
  },

  // default request timeout
  requestTimeout: 2e4,
  requestExtraLongTimeout: 10e5,

  // pikaday config
  pikaday: {
    firstDay: 1,
    i18n: {
      previousMonth: 'Zurück',
      nextMonth: 'Vor',
      months: monthLabels,
      weekdays: dayLabels,
      weekdaysShort: shortDayLabels,
    },
  },
  monthNames: monthLabels,

  // owl carousel config
  owlCarousel: {
    dotClass: 'carousel_dot',
    dotsClass: 'carousel_dots',
    dragClass: 'carousel_drag',
    grabClass: 'carousel_grab',
    itemClass: 'carousel_item',
    loadedClass: 'carousel_loaded',
    loadingClass: 'carousel_loading',
    navClass: ['carousel_prev', 'carousel_next'],
    navContainerClass: 'carousel_nav',
    refreshClass: 'carousel_refresh',
    responsiveClass: 'carousel_responsive',
    stageClass: 'carousel_stage',
    stageOuterClass: 'carousel_stageOuter',
    navText: ['', ''],
  },

  // jQuery tageditor config
  tagEditor: {
    animateDelete: 0,
    delimiter: ',',
    forceLowercase: false,
    maxLength: 30,
  },

  passwordChecks: [
    // any password
    /^.*$/,
    // at least 8 characters, must include at least one of each lower case
    // letter and one upper case letter OR numeric digit
    /^(?=.*[a-z])((?=.*[A-Z])|(?=.*\d)).{8,}$/,
    // at least 8 characters, must include at least one lower case
    // letter and special character and one upper case letter OR or one numeric digit
    /^(?=.*[a-z])((?=.*[A-Z])|(?=.*\d))(?=.*[^A-Za-z0-9]).{8,}$/,
    // at least 12 characters, must include at least one lower case
    // letter and special character and one upper case letter OR or one numeric digit
    /^(?=.*[a-z])((?=.*[A-Z])|(?=.*\d))(?=.*[^A-Za-z0-9]).{12,}$/,
  ],

  // validate email
  // emailCheck: /^([a-z0-9!#$%&'*+./=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z](?:[a-z-]*[a-z])$/i,
  emailCheck: /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,

  ibanCheck: /^([A-Z]{2})(\d{2})(.+)$/,

  googleAPI: {
    url: 'https://www.google.com/maps/embed/v1/place?key=',
    browserUrl: 'https://www.google.com/maps?q=',
    iconUrl: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
    key: 'AIzaSyD3p3sq26-teWD1Kpr_EpOjV52RpoMtgfE',
  },
  googleTagManager: {
    key: 'GTM-W4CMLWQ',
  },

  companyTypes: [
    { label: 'Kleinunternehmer', value: 'smallbusiness' },
    { label: 'Freiberufler', value: 'freelancer' },
    { label: 'Gewerbetreibender', value: 'trader' },
    { label: 'Personengesellschaft', value: 'partnership' },
    { label: 'Kapitalgesellschaft', value: 'corporation' },
  ],

  countries,
  defaultCountryAsISO2: 'DE',
  countryCodeATasISO2: 'AT',

  currencyFormat: {
    symbol: '€',
    format: '%v %s',
    decimal: ',',
    thousand: '.',
    precision: 2,
  },

  // date formats
  dateFormat: {
    api: 'YYYY-MM-DD',
    client: 'DD.MM.YYYY',
    dateTime: 'DD.MM.YYYY - hh:mm',
  },

  paymentBannerUrl: '',

  agGridLicense: {
    key: 'Using_this_{AG_Grid}_Enterprise_key_{AG-066921}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{deltra_Business_Software_GmbH_&_Co._KG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{orgaMAX_Online}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{orgaMAX_Online}_need_to_be_licensed___{orgaMAX_Online}_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_November_2025}____[v3]_[01]_MTc2MzQyNDAwMDAwMA==2a2ca49c48de413b00758bd9ac3c8305',
  },

  transactionResourceURL: `${resourceHost}transaction`,

  advancedDatePickerType: {
    YEAR: 'year',
    QUARTER: 'quarter',
    MONTH: 'month',
    CUSTOM: 'custom',
  },
  advancedDatepicker,
  advancedDatePickerLabels: {
    year: advancedDatepicker.wholeYear,
    quarter: {
      1: advancedDatepicker.Q1,
      2: advancedDatepicker.Q2,
      3: advancedDatepicker.Q3,
      4: advancedDatepicker.Q4,
    },
    month: monthLabels.reduce((result, item, index) => {
      result[index + 1] = item
      return result
    }, {}),
  },
}
